module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "rows": _vm.rowCount,
      "placeholder": _vm.placeholder,
      "disabled": _vm.isDisabled
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0158d2b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VATextarea.vue
// module id = 487
// module chunks = 1